export const ADD_JOBS = 'ADD_JOBS'
export const ADD_DIALOGS = 'ADD_DIALOGS'
export const COUNT_MESSAGES = 'COUNT_MESSAGES'
export const SELECT_JOB = 'SELECT_JOB'
export const JOBS_STATISTICS = 'JOBS_STATISTICS'
export const SHOW_ASSIGNED_JOBS = 'SHOW_ASSIGNED_JOBS'

export const addJobs = (jobs, dispatch) => {
  const dispatchObj = { type: ADD_JOBS, jobs }
  return dispatch(dispatchObj)
}

export const countMessages = (dialogId, dispatch) => {
  const dispatchObj = { type: COUNT_MESSAGES, dialogId }
  return dispatch(dispatchObj)
}

export const addDialogs = (jobId, dialogId, dispatch) => {
  const dispatchObj = { type: ADD_DIALOGS, jobId, dialogId }
  return dispatch(dispatchObj)
}

export const selectJob = (job, index, dispatch) => {
  return dispatch({ type: SELECT_JOB, job, index })
}

export const updateJobStatistics = (userId, jobs, dispatch) => {
  let assignedJobs = 0
  let unviewedJobs = 0
  let viewedJobs = 0
  let myAssignedJobs = 0

  jobs.forEach(({ lastFlag: { userId: agentId, viewedAt }, agents = [] }) => {
    assignedJobs += agentId ? 1 : 0
    unviewedJobs += viewedAt ? 0 : 1
    viewedJobs += viewedAt ? 1 : 0
    myAssignedJobs += agents.includes(userId) ? 1 : 0
  })

  return dispatch({ type: JOBS_STATISTICS, jobStatistics: { assignedJobs, unviewedJobs, viewedJobs, myAssignedJobs } })
}

export const updateShowAssignedJobs = (value, myId, dispatch) => {
  return dispatch({ type: SHOW_ASSIGNED_JOBS, showAssignedJobs: value, myId })
}
